export const PlatformEdition = {
  CREATOR: 'creator',
  CORPORATE: 'corporate',
} as const;

export type PlatformEdition = (typeof PlatformEdition)[keyof typeof PlatformEdition];

export const PLATFORM_FEATURES = {
  /** History of course sales. */
  SALES_HISTORY: 'sales_history',
  /** Payment methods the platform accepts from students. */
  PAYMENT_METHODS: 'payment_methods',
  /** Paid tariffs of a course (prices, plans for students). */
  COURSE_TARIFFS: 'course_tariffs',
  /** Public, marketing-facing pages: course landing and platform catalog. */
  PUBLIC_PAGES: 'public_pages',
  /** Telegram sales chatbot. */
  CHATBOT: 'chatbot',
  /** Org structure, assignments, employee import and the training-control report. */
  CORPORATE_LEARNING: 'corporate_learning',
} as const;

export type PlatformFeature = (typeof PLATFORM_FEATURES)[keyof typeof PLATFORM_FEATURES];
export type PlatformFeatureMatrix = Partial<Record<PlatformFeature, boolean>>;
